const BucketsIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24" height="24" viewBox="0 0 24 24"
		fill="currentColor"
		stroke="none"
		{...props}
	>
		<path d="M12 3C7.58 3 4 4.79 4 7C4 9.21 7.58 11 12 11C16.42 11 20 9.21 20 7C20 4.79 16.42 3 12 3ZM5 9V12C5 14.21 7.58 16 12 16C16.42 16 19 14.21 19 12V9C19 11.21 16.42 13 12 13C7.58 13 5 11.21 5 9ZM6 14V17C6 19.21 7.58 21 12 21C16.42 21 18 19.21 18 17V14C18 16.21 16.42 18 12 18C7.58 18 6 16.21 6 14Z" />
	</svg>
)

export default BucketsIcon